import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostMunicipalities_municipalityIdExternalApiAdd_secret = z.any()
export type TagsPostMunicipalities_municipalityIdExternalApiAdd_secret = z.infer<typeof tagsPostMunicipalities_municipalityIdExternalApiAdd_secret>

export const descriptionPostMunicipalities_municipalityIdExternalApiAdd_secret = z.any()
export type DescriptionPostMunicipalities_municipalityIdExternalApiAdd_secret = z.infer<typeof descriptionPostMunicipalities_municipalityIdExternalApiAdd_secret>

export const paramsPostMunicipalities_municipalityIdExternalApiAdd_secret = z.object({ "municipalityId": z.string().uuid() })
export type ParamsPostMunicipalities_municipalityIdExternalApiAdd_secret = z.infer<typeof paramsPostMunicipalities_municipalityIdExternalApiAdd_secret>

export const bodyPostMunicipalities_municipalityIdExternalApiAdd_secret = z.object({ "providerName": z.string().min(1), "clientId": z.string().min(1), "apiKey": z.string().min(1) })
export type BodyPostMunicipalities_municipalityIdExternalApiAdd_secret = z.infer<typeof bodyPostMunicipalities_municipalityIdExternalApiAdd_secret>

export const responsePostMunicipalities_municipalityIdExternalApiAdd_secret = z.any()
export type ResponsePostMunicipalities_municipalityIdExternalApiAdd_secret = z.infer<typeof responsePostMunicipalities_municipalityIdExternalApiAdd_secret>

interface IPostMunicipalities_municipalityIdExternalApiAdd_secret extends BaseMethodType {
  tags: TagsPostMunicipalities_municipalityIdExternalApiAdd_secret,
  description: DescriptionPostMunicipalities_municipalityIdExternalApiAdd_secret,
  params: ParamsPostMunicipalities_municipalityIdExternalApiAdd_secret,
  body: BodyPostMunicipalities_municipalityIdExternalApiAdd_secret,
  response: ResponsePostMunicipalities_municipalityIdExternalApiAdd_secret
}
export const URL = '/municipalities/:municipalityId/externalApi/add-secret'
export const validation = {
  post: {
    tags: tagsPostMunicipalities_municipalityIdExternalApiAdd_secret,
    description: descriptionPostMunicipalities_municipalityIdExternalApiAdd_secret,
    params: paramsPostMunicipalities_municipalityIdExternalApiAdd_secret,
    body: bodyPostMunicipalities_municipalityIdExternalApiAdd_secret,
    response: responsePostMunicipalities_municipalityIdExternalApiAdd_secret
  }
}
export interface Municipalities_municipalityIdExternalApiAdd_secret extends BaseRouteType {
  post: IPostMunicipalities_municipalityIdExternalApiAdd_secret
}